import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {StepTypeInfo} from 'pipelines/hooks/useStepTypeInfosQuery';

/**
 * Resolve a step type's user-facing name from the step-type infos query.
 *
 * The infos map is empty while `useStepTypeInfos` is loading; until then we fall back to the raw
 * step type value so titles/labels have a readable (if imperfect) value rather than being blank.
 */
export function getUserFacingStepTypeName(
  stepType: PipelineStepType,
  stepTypeInfos: ReadonlyMap<PipelineStepType, StepTypeInfo>
): string {
  return stepTypeInfos.get(stepType)?.userFacingName ?? stepType;
}
